var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19961 7.7C9.18783 7.7 10.7996 6.08822 10.7996 4.1C10.7996 2.11177 9.18783 0.5 7.19961 0.5C5.21138 0.5 3.59961 2.11177 3.59961 4.1C3.59961 6.08822 5.21138 7.7 7.19961 7.7Z",
    stroke: "#E95A1A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4499C14.4 16.6864 14.4 18.4999 7.2 18.4999C0 18.4999 0 16.6864 0 14.4499C0 12.2134 3.2238 10.3999 7.2 10.3999C11.1762 10.3999 14.4 12.2134 14.4 14.4499Z",
    stroke: "#E95A1A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/group1.d2ad8087b013f6c1d625e11f94ba6cea.svg";
export { ForwardRef as ReactComponent };